var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2Winter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-2",
    serifId: "layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.002,105.199l-0.002,107.789l3000,2.323l0,-106.528l-3000,-3.584Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.002,105.199l-0.002,107.789l3000,2.323l0,-106.528l-3000,-3.584Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1687.8,140.501c1.035,0.079 1.822,0.962 1.783,1.999c-0.04,1.038 -0.893,1.858 -1.931,1.858c-121.261,-0.012 -451.166,-0.046 -654.666,-0.067c-1.414,-0.011 -2.564,-1.143 -2.597,-2.556c-0.032,-1.414 1.064,-2.598 2.476,-2.674c0.005,-0.001 0.009,-0.001 0.014,-0.001c29.442,-1.578 58.222,-4.594 88.707,-4.779c31.949,-0.195 61.236,3.889 92.277,4.981c73.408,2.582 141.969,-6.863 208.841,-3.216c73.416,4.004 131.966,-0.626 181.459,-0.125c22.001,0.223 55.938,2.463 83.637,4.58Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.58
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2138.04,163.01c2.286,0.112 4.066,2.026 4.01,4.313c-0.056,2.288 -1.927,4.113 -4.215,4.113c-152.055,-0.018 -404.407,-0.045 -571.518,-0.062c-1.414,-0.01 -2.564,-1.142 -2.597,-2.556c-0.033,-1.414 1.064,-2.598 2.476,-2.673c0.004,-0.002 0.009,-0.002 0.013,-0.002c29.443,-1.578 58.222,-4.593 88.707,-4.779c31.949,-0.195 61.236,3.889 92.277,4.981c73.409,2.582 141.969,-6.863 208.841,-3.215c73.416,4.004 131.966,-0.626 181.46,-0.126c0.181,0.002 0.363,0.004 0.546,0.006Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1817.85,162.148c0,-0 -0.462,3.326 4.681,3.104c5.143,-0.221 30.049,-0.393 33.792,-1.515c3.742,-1.123 1.991,-3.252 1.991,-3.252c-0,0 -0.224,1.322 -4.635,1.698c-4.411,0.376 -28.373,1.562 -30.741,1.554c-3.536,-0.013 -5.088,-1.589 -5.088,-1.589Z",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.38,147.041c-4.365,5.61 -10.372,5.018 -15.798,7.504c-4.832,2.214 -6.043,7.188 -0.371,7.06c3.384,-0.077 22.255,-0.312 26.459,-2.012c1.262,-0.51 0.759,-3.464 0.614,-4.789c-0.287,-2.624 -0.643,-5.246 -0.817,-7.895",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1849.69,
    y: 159.224,
    width: 1.801,
    height: 4.085,
    style: {
      fill: "#00425c"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1959.08,85.914c0,-0 3.267,-0.777 1.194,-5.489c-2.073,-4.712 -11.272,-27.857 -13.677,-30.937c-2.404,-3.08 -3.752,-0.676 -3.752,-0.676c0,0 1.313,-0.271 3.264,3.703c1.951,3.974 11.753,25.871 12.605,28.081c1.272,3.299 0.366,5.318 0.366,5.318Z",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935.74,67.603c6.812,2.032 8.44,7.845 12.726,11.998c3.817,3.698 8.891,3.022 6.713,-2.216c-1.3,-3.126 -8.367,-20.625 -11.477,-23.925c-0.934,-0.991 -3.504,0.549 -4.686,1.165c-2.341,1.221 -4.689,2.729 -7.094,3.852",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.14,55.625l0.654,1.678l3.806,-1.482l-0.653,-1.679l-3.807,1.483Z",
    style: {
      fill: "#00425c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1843.75,74.029c0,-0 -0.462,57.935 -0.564,70.737c-0.013,1.524 1.064,2.84 2.56,3.129c2.269,0.347 4.705,0.39 6.884,0.11c1.369,-0.219 2.43,-1.313 2.608,-2.688c3.134,-23.904 6.881,-48.271 13.512,-73.371l-25,2.083Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.95,21.839c0,0 7.215,-5.199 12.029,-3.552c2.891,0.99 -0.676,4.03 -3.988,6.301c0.466,0.006 0.996,-0.054 1.429,0.155c0.355,0.171 0.231,0.604 -0.014,0.806c-0.112,0.091 -0.238,0.167 -0.363,0.239c-0.192,0.112 -0.391,0.214 -0.598,0.296c-1.476,0.588 -3.075,0.883 -4.637,1.122c-0.082,0.013 -0.111,0.063 -0.111,0.063l-3.747,-5.43",
    style: {
      fill: "#ffd17d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.83,57.8c-0,0 -10.146,-3.9 -12.455,0.594c-1.403,2.732 3.046,4.064 6.794,4.691c-0.57,0.215 -2.648,1.091 -2.017,2.009c0.493,0.717 2.059,0.325 2.767,0.258c1.152,-0.111 2.644,-0.252 3.481,-1.159c0.533,-0.576 0.55,-1.474 0.682,-2.208c0.249,-1.395 0.498,-2.79 0.748,-4.185",
    style: {
      fill: "#ffd17d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.14,80.792c0,-0 37.108,8.455 64.197,-0.513c16.664,-5.517 25.033,-10.22 27.813,-11.951c0.663,-0.463 0.986,-1.278 0.82,-2.07c-0.571,-2.595 -1.519,-5.337 -2.954,-7.567c-0.582,-0.84 -1.703,-1.107 -2.601,-0.62c-4.424,2.245 -17.751,8.337 -31.76,7.745c-17.155,-0.726 -43.402,-10.537 -43.402,-10.537l-12.113,25.513Z",
    style: {
      fill: "#ffe8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.05,34.028c-0,-0 -15.634,18.956 -24.6,20.79c-11.964,2.448 -20.519,2.35 -24.333,2.108c-1.24,-0.137 -2.374,0.713 -2.591,1.942c-0.177,0.961 -0.377,2.094 -0.548,3.063c-0.219,1.243 0.572,2.44 1.801,2.726c6.212,1.355 24.289,4.677 36.85,0.295c15.515,-5.413 21.192,-12.668 21.192,-12.668l-7.771,-18.256Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.07,85.218c-0.582,0.71 -1.501,1.054 -2.406,0.9c-17.241,-4.056 -43.908,-49.671 -27.628,-57.455c11.621,-5.555 34.075,19.948 54.735,23.044c4.785,0.718 -16.54,23.686 -24.701,33.511Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1811.78,28.885c11.738,-6.817 37.306,-0.418 62.501,-7.523c0.902,-0.259 1.871,0.054 2.451,0.791c0.614,0.773 1.421,1.798 2.138,2.71c0.428,0.543 0.59,1.249 0.443,1.924c-0.147,0.676 -0.589,1.25 -1.204,1.566c-16.859,8.724 -28.632,11.513 -41.374,10.575l-24.955,-10.043Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.83,19.862c-0,3.472 1.76,6.23 -0,8.334c-1.761,2.103 2.083,2.083 2.083,2.083c0,-0 3.9,9.666 10.417,4.167c6.516,-5.5 5.822,-19.239 -0,-22.917c-5.823,-3.678 -12.5,-0.695 -12.5,8.333Z",
    style: {
      fill: "#c7ab87"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1812.93,17.314c-0,-0 3.301,-10.46 -3.372,-13.032c-3.394,-1.308 -11.885,5.103 -12.903,9.423c-1.019,4.319 16.275,3.609 16.275,3.609Z",
    style: {
      fill: "#ffe8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.83,15.696c2.43,3.472 11.107,5.65 17.392,5.273c1.427,-0.086 1.885,-3.798 -0.101,-4.005c-4.39,-0.457 -12.568,-2.767 -15.843,-4.423c-1.532,-0.774 -2.012,2.35 -1.448,3.155Z",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1811.45,
    cy: 2.834,
    rx: 3.043,
    ry: 2.834,
    style: {
      fill: "#00425c"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1814.62,24.8c-2.548,-1.184 -5.432,7.147 -13.017,12.23c-0.807,0.54 -2.968,3.164 -1.799,4.166c1.795,1.539 5.228,-0.018 6.989,-0.888c4.65,-2.297 12.368,-13.397 7.827,-15.508Z",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1812.71,33.978c-0,-0 18.471,-1.482 26.906,-4.188c12.733,-4.083 16.565,-9.758 12.01,-11.386c-4.374,-1.563 -23.282,6.841 -35.736,8.163l-3.18,7.411Z",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.98,31.946c0,-0 9.272,16.044 15.337,22.499c9.157,9.746 15.927,10.77 15.441,5.956c-0.467,-4.621 -16.177,-18.087 -22.72,-28.766l-8.058,0.311Z",
    style: {
      fill: "#00425c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1828.27,
    y: 160.626,
    width: 1.631,
    height: 3.653,
    style: {
      fill: "#00425c"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.59852,106.278,-106.278,1.59852,1661.34,106.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a3d9ea",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#478a95",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2Winter);
export default __webpack_public_path__ + "static/media/layer2-winter.6021eab46d58600e7ecdf5a3175eac37.svg";
export { ForwardRef as ReactComponent };